import { render } from "./pageFooter.vue?vue&type=template&id=40847b0c&scoped=true"
const script = {}

import "./pageFooter.vue?vue&type=style&index=0&id=40847b0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40847b0c"]])

export default __exports__